var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "el-form",
        {
          ref: "systemInfoConfig",
          staticStyle: { width: "600px" },
          attrs: { model: _vm.form, "label-width": "120px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "系统版本" } },
            [
              _c("el-tag", { attrs: { type: "success", effect: "dark" } }, [
                _vm._v(" V4.0"),
              ]),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "公众号登录", prop: "openWxMpLogin" } },
            [
              _c("el-switch", {
                attrs: { placeholder: "https://pro.tduckcloud.com/" },
                model: {
                  value: _vm.form.openWxMpLogin,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "openWxMpLogin", $$v)
                  },
                  expression: "form.openWxMpLogin",
                },
              }),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-left": "10px",
                    "font-size": "12px",
                    color: "#8a8f97",
                  },
                },
                [
                  _vm._v(
                    " * 开启公众号登录后，请在配置文件中进行公众号参数配置并重新编译重启后端 "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "基础域名",
                prop: "webBaseUrl",
                rules: [
                  {
                    required: true,
                    message: "请输入项目前端所在域名",
                    trigger: "blur",
                  },
                ],
              },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "https://pro.tduckcloud.com/" },
                model: {
                  value: _vm.form.webBaseUrl,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "webBaseUrl", $$v)
                  },
                  expression: "form.webBaseUrl",
                },
              }),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-left": "10px",
                    "font-size": "12px",
                    color: "#8a8f97",
                  },
                },
                [_vm._v("* 请填写站点实际域名")]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v(" 保存")]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }